import React from 'react';
import VehicleCardListContainer from '~/App/shared/components/VehicleCardList/components/VehicleCardListContainer';
import VehicleCardListItem from '~/App/shared/components/VehicleCardList/components/VehicleCardListItem';
import AuctionLoadingCard from '~/App/shared/components/AuctionLoadingCard';

interface VehicleLoadingCardsProps {
  numberOfCards?: number;
}

const VehicleLoadingCards = ({
  numberOfCards = 4
}: VehicleLoadingCardsProps) => {
  return (
    <VehicleCardListContainer>
      {Array.from({ length: numberOfCards }, (_, index) => (
        <VehicleCardListItem key={`product-card-loader-${index}`}>
          <AuctionLoadingCard />
        </VehicleCardListItem>
      ))}
    </VehicleCardListContainer>
  );
};

export default VehicleLoadingCards;
